import React from 'react';
import { DraftFunction } from 'use-immer';

import { PaymentProcessor } from '@r6digital/r6pay-types/types/PaymentProcessor';
import Descriptor from '@r6digital/rapidstor-types/react/entities/Descriptor';
import UnitType from '@r6digital/rapidstor-types/react/entities/UnitType';
import Deal from '@r6digital/rapidstor-types/types/Deal';
import InsuranceCoverage from '@r6digital/rapidstor-types/types/InsuranceCoverage';
import { LineItem } from '@r6digital/rapidstor-types/types/Merchandise';
import { BaseReservation, CostRetrieveResponse } from '@r6digital/rapidstor-types/types/Reservation';

import { WizardValidationError } from '@/core/types/Wizard';
import { StripePaymentIntent } from '@/features/rapidstor/services/R6PayService';

import SimplifiedCheckoutForm from './SimplifiedCheckoutForm';
import SimplifiedCheckoutSummary from './SimplifiedCheckoutSummary';

import classes from './styles.module.scss';

interface Props {
    descriptor: Descriptor | undefined;
    unitType: UnitType | undefined;
    deal: Deal | undefined;
    costRetrieve: CostRetrieveResponse | undefined;
    cart: LineItem[];
    merchandiseDiscount: number;
    form: Record<string, string>;
    update: (key: string, event: React.BaseSyntheticEvent) => void;
    updateForm: (arg: Record<string, string> | DraftFunction<Record<string, string>>) => void;
    updateNeededDate: (date: Date) => void;
    updateExpiryDate: (values: Record<string, string | number>) => void;
    updateReservation: (doCostRetrieve: boolean, insuranceCoverage?: string) => void;
    validationErrors: WizardValidationError[];
    availableInsuranceCoverage: InsuranceCoverage[] | undefined;
    reservation: BaseReservation | undefined;
    moveInLoading: boolean;
    pricingPending: boolean;
    moveInError: string | undefined;
    setMoveInError: (error: string | undefined) => void;
    processBooking: (payment_method?: PaymentProcessor) => void;
    r6PayService: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        service: any;
    };
    confirmBookingButtonText: (confirmText?: string) => string;
    stripeIntent: StripePaymentIntent | null;
}

export default function SimplifiedCheckout({
    descriptor,
    unitType,
    deal,
    costRetrieve,
    cart,
    merchandiseDiscount,
    form,
    update,
    updateForm,
    updateNeededDate,
    updateExpiryDate,
    updateReservation,
    validationErrors,
    availableInsuranceCoverage,
    reservation,
    moveInLoading,
    pricingPending,
    moveInError,
    setMoveInError,
    processBooking,
    r6PayService,
    confirmBookingButtonText,
    stripeIntent,
}: Props) {
    return (
        <div className={classes.simplifiedCheckout}>
            <SimplifiedCheckoutSummary
                descriptor={descriptor}
                unitType={unitType}
                deal={deal}
                costRetrieve={costRetrieve}
                cart={cart}
                merchandiseDiscount={merchandiseDiscount}
            />
            <SimplifiedCheckoutForm
                form={form}
                update={update}
                updateForm={updateForm}
                updateNeededDate={updateNeededDate}
                updateExpiryDate={updateExpiryDate}
                updateReservation={updateReservation}
                validationErrors={validationErrors}
                availableInsuranceCoverage={availableInsuranceCoverage}
                reservation={reservation}
                moveInLoading={moveInLoading}
                pricingPending={pricingPending}
                moveInError={moveInError}
                setMoveInError={setMoveInError}
                processBooking={processBooking}
                r6PayService={r6PayService}
                confirmBookingButtonText={confirmBookingButtonText}
                stripeIntent={stripeIntent}
            />
        </div>
    );
}
